(function() { window.GUID_e63dc58c_701a_442f_b031_26cdaf9011bc = { getGuid: function() { return "e63dc58c-701a-442f-b031-26cdaf9011bc"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let EncountersFormat;
        (function (EncountersFormat) {
            EncountersFormat[EncountersFormat["Cards"] = 0] = "Cards";
            EncountersFormat[EncountersFormat["Table"] = 1] = "Table";
            EncountersFormat[EncountersFormat["BergerByNumber"] = 2] = "BergerByNumber";
            EncountersFormat[EncountersFormat["BergerByName"] = 3] = "BergerByName";
        })(EncountersFormat = Enumeration.EncountersFormat || (Enumeration.EncountersFormat = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=EncountersFormat.pre.js.map
